import React, {
  createContext,
  useContext,
  useState,
  useEffect
} from "react";

const AuthContext = createContext(null);


/* HOOK PERSONALIZADO */

export const useAuth = () => {

  const ctx = useContext(AuthContext);

  if (!ctx) {

    throw new Error(
      "useAuth debe usarse dentro de AuthProvider"
    );

  }

  return ctx;

};


/* PROVIDER */

export const AuthProvider = ({ children }) => {

  const [user, setUser] = useState(null);


  /* mantener sesión activa al recargar */

  useEffect(() => {

    const usuarioGuardado =
      localStorage.getItem("usuario");

    if (usuarioGuardado) {

      setUser(
        JSON.parse(usuarioGuardado)
      );

    }

  }, []);



  /* LOGIN */

  const login = async (correo, clave) => {

    try {

      const res = await fetch(
        "http://localhost:8080/idatsakura2026/public/api/login",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json"
          },

          body: JSON.stringify({
            correo,
            clave
          })
        }
      );

      const data = await res.json();


      if (data.success) {

        /* guardar usuario en estado */

        setUser(data.usuario);


        /* guardar usuario en localStorage */

        localStorage.setItem(
          "usuario",
          JSON.stringify(data.usuario)
        );


        /* devolver datos usuario */

        return data.usuario;

      }


      return null;


    } catch {

      return null;

    }

  };



  /* LOGOUT */

  const logout = () => {

    setUser(null);

    localStorage.removeItem("usuario");

  };



  return (

    <AuthContext.Provider
      value={{
        user,
        login,
        logout
      }}
    >

      {children}

    </AuthContext.Provider>

  );

};